<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content bill-payment">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;">
        <el-tab-pane v-if="tabNotSubmittedIsShowed" :label="$t('Payment.notSubmitted')" name="notSubmitted">
          <tab-bill-payment-jc v-if="notSubmittedIsShow" :application-status="0" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane v-if="tabAwaitBusinessApprovalIsShowed" :label="$t('Payment.awaitBusinessApproval')" name="awaitBusinessApproval" :lazy="true">
          <tab-bill-payment-jc v-if="awaitBusinessApprovalIsShow" :application-status="1" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane v-if="tabAwaitFinancialApprovalIsShowed" :label="$t('Payment.awaitFinancialApproval')" name="awaitFinancialApproval" :lazy="true">
          <tab-bill-payment-jc v-if="awaitFinancialApprovalIsShow" :application-status="2" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane v-if="tabApprovalIsShowed" :label="$t('Payment.approval')" name="approval" :lazy="true">
          <tab-bill-payment-jc v-if="approvalIsShow" :application-status="3" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane v-if="tabUnpaidIsShowed" :label="$t('Payment.unpaid')" name="unpaid" :lazy="true">
          <tab-bill-payment-jc v-if="unpaidIsShow" :application-status="4" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane v-if="tabAllIsShowed" :label="$t('Payment.all')" name="all" :lazy="true">
          <tab-bill-payment-jc v-if="allIsShow" :application-status="5" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane v-if="tabNosubmitWeaverIsShowed" :label="$t('Payment.NosubmitWeaver')" name="nosubmitWeaver" :lazy="true">
          <tab-bill-payment-jc v-if="nosubmitWeaverIsShow" :application-status="7" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane v-if="tabWeaverApprovingIsShowed" :label="$t('Payment.WeaverApproving')" name="weaverApproving" :lazy="true">
          <tab-bill-payment-jc v-if="weaverApprovingIsShow" :application-status="8" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane v-if="tabWeaverApprovedIsShowed" :label="$t('Payment.WeaverApproved')" name="weaverApproved" :lazy="true">
          <tab-bill-payment-jc v-if="weaverApprovedIsShow" :application-status="9" :show-wht="true" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabBillPaymentJc from '@/views/cargo/v0/Clearing/components/BillPayment/tabBillPaymentJc'

export default {
  name: 'BillPaymentJc',
  components: { TabBillPaymentJc },
  data() {
    return {
      activeTabName: 'notSubmitted',
      tabNotSubmittedIsShowed: this.$checkPermission(['tab_ACPayAuth_fbWait']),
      tabAwaitBusinessApprovalIsShowed: this.$checkPermission(['tab_ACPayAuth_fbApproval']),
      tabAwaitFinancialApprovalIsShowed: this.$checkPermission(['tab_ACPayAuth_fbFinanceVerify']),
      tabApprovalIsShowed: this.$checkPermission(['tab_ACPayAuth_fbConfirm']),
      tabUnpaidIsShowed: this.$checkPermission(['tab_ACPayAuth_fbUnverify']),
      tabAllIsShowed: this.$checkPermission(['tab_ACPayAuth_fbAll']),
      tabNosubmitWeaverIsShowed: this.$checkPermission(['tab_ACPayAuth_fbNosubmitWeaver']),
      tabWeaverApprovingIsShowed: this.$checkPermission(['tab_ACPayAuth_fbWeaverApproving']),
      tabWeaverApprovedIsShowed: this.$checkPermission(['tab_ACPayAuth_fbWeaverApproved']),
      notSubmittedIsShowed: false,
      awaitBusinessApprovalIsShowed: false,
      awaitFinancialApprovalIsShowed: false,
      approvalIsShowed: false,
      unpaidIsShowed: false,
      allIsShowed: false,
      nosubmitWeaverIsShowed: false,
      weaverApprovingIsShowed: false,
      weaverApprovedIsShowed: false
    }
  },
  computed: {
    notSubmittedIsShow() {
      if (this.activeTabName === 'notSubmitted' && !this.notSubmittedIsShowed) {
        this.notSubmittedIsShowed = true
      }
      return this.notSubmittedIsShowed
    },
    awaitBusinessApprovalIsShow() {
      if (this.activeTabName === 'awaitBusinessApproval' && !this.awaitBusinessApprovalIsShowed) {
        this.awaitBusinessApprovalIsShowed = true
      }
      return this.awaitBusinessApprovalIsShowed
    },
    awaitFinancialApprovalIsShow() {
      if (this.activeTabName === 'awaitFinancialApproval' && !this.awaitFinancialApprovalIsShowed) {
        this.awaitFinancialApprovalIsShowed = true
      }
      return this.awaitFinancialApprovalIsShowed
    },
    approvalIsShow() {
      if (this.activeTabName === 'approval' && !this.approvalIsShowed) {
        this.approvalIsShowed = true
      }
      return this.approvalIsShowed
    },
    unpaidIsShow() {
      if (this.activeTabName === 'unpaid' && !this.unpaidIsShowed) {
        this.unpaidIsShowed = true
      }
      return this.unpaidIsShowed
    },
    allIsShow() {
      if (this.activeTabName === 'all' && !this.allIsShowed) {
        this.allIsShowed = true
      }
      return this.allIsShowed
    },
    nosubmitWeaverIsShow() {
      if (this.activeTabName === 'nosubmitWeaver' && !this.nosubmitWeaverIsShowed) {
        this.nosubmitWeaverIsShowed = true
      }
      return this.nosubmitWeaverIsShowed
    },
    weaverApprovingIsShow() {
      if (this.activeTabName === 'weaverApproving' && !this.weaverApprovingIsShowed) {
        this.weaverApprovingIsShowed = true
      }
      return this.weaverApprovingIsShowed
    },
    weaverApprovedIsShow() {
      if (this.activeTabName === 'weaverApproved' && !this.weaverApprovedIsShowed) {
        this.weaverApprovedIsShowed = true
      }
      return this.weaverApprovedIsShowed
    }
  },
  created() {
    this.defaultActiveTabName()
  },
  methods: {
    defaultActiveTabName() {
      if (this.tabNotSubmittedIsShowed) {
        this.activeTabName = 'notSubmitted'
      } else if (this.tabAwaitBusinessApprovalIsShowed) {
        this.activeTabName = 'awaitBusinessApproval'
      } else if (this.tabAwaitFinancialApprovalIsShowed) {
        this.activeTabName = 'awaitFinancialApproval'
      } else if (this.tabApprovalIsShowed) {
        this.activeTabName = 'approval'
      } else if (this.tabUnpaidIsShowed) {
        this.activeTabName = 'unpaid'
      } else if (this.tabAllIsShowed) {
        this.activeTabName = 'all'
      } else if (this.tabNosubmitWeaverIsShowed) {
        this.activeTabName = 'nosubmitWeaver'
      } else if (this.tabWeaverApprovingIsShowed) {
        this.activeTabName = 'weaverApproving'
      } else if (this.tabWeaverApprovedIsShowed) {
        this.activeTabName = 'weaverApproved'
      }
    }
  }
}
</script>

<style lang="scss">
</style>
